import React, { useEffect, useState } from 'react';
const buyers = [{
  name: 'Martín',
  city: 'Buenos Aires'
}, {
  name: 'Lucía',
  city: 'Córdoba'
}, {
  name: 'Diego',
  city: 'Rosario'
}, {
  name: 'Valentina',
  city: 'Mendoza'
}, {
  name: 'Juan',
  city: 'La Plata'
}, {
  name: 'Camila',
  city: 'Tucumán'
}, {
  name: 'Nicolás',
  city: 'Mar del Plata'
}, {
  name: 'Sofía',
  city: 'Salta'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyerIndex, setBuyerIndex] = useState(0);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Cycle logic
    const cycleTimer = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setBuyerIndex(prev => (prev + 1) % buyers.length);
        setIsVisible(true);
      }, 1000); // Wait 1s while hidden before showing next
    }, 12000); // Show new popup every 12 seconds
    return () => {
      clearTimeout(initialTimer);
      clearInterval(cycleTimer);
    };
  }, [isDismissed]);
  if (isDismissed) return null;
  const currentBuyer = buyers[buyerIndex];
  return <div className={`fixed bottom-4 left-4 z-50 transition-all duration-500 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0 pointer-events-none'}`} data-id="element-128">
      <div className="bg-white rounded-lg shadow-2xl border-l-4 border-green-500 p-4 pr-8 max-w-xs sm:max-w-sm relative flex items-center gap-3" data-id="element-129">
        <button onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" aria-label="Cerrar" data-id="element-130">
          ✕
        </button>

        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-131">
          <span className="text-xl" data-id="element-132">🌱</span>
        </div>

        <div data-id="element-133">
          <p className="text-sm text-gray-800 font-medium" data-id="element-134">
            <span className="font-bold" data-id="element-135">{currentBuyer.name}</span> de{' '}
            {currentBuyer.city}
          </p>
          <p className="text-xs text-gray-500 mt-0.5" data-id="element-136">
            acaba de comprar El Manual del Jardinero
          </p>
          <p className="text-[10px] text-green-600 font-bold mt-1 uppercase" data-id="element-137">
            Hace unos minutos
          </p>
        </div>
      </div>
    </div>;
}